export const bgAuth = {
  styles: {
    global: (props) => ({
      body: {
        bg: "linear-gradient(159.02deg, #0F123B 14.25%, #090D2E 56.45%, #020515 86.14%)",

        bgSize: "cover",
        bgPosition: "center center",
      },
    }),
  },
};
